<template>
    <Container class="bg-yellow-500 relative z-5" style="overflow-x: visible;">
        <div class="flex flex-row relative" style="overflow-x: visible;">
            <div class="text-center mx-auto text-xs py-0 my-0">
                {{promotion.text}}
            </div>
        </div>
    </Container>
</template>

<script setup lang="ts">
import Container from "./Container"

const product = defineProps(["promotion"])

</script>

<style scoped>

</style>
